import styled from 'styled-components';

export const ModalBackground = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
  padding: 15px;
  background-color: #000000D9;
`;